/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./PuffNotice.scss";

function PuffNotice({ ...restProps }) {
  return (
    <div {...restProps} className={cn("puff-notice scope-cb8cd9f3", restProps.className)}>
      <div className="puff-notice__bulb-icon-wrapper scope-cb8cd9f3">
        <UseSvg
          className="puff-notice__bulb-icon scope-cb8cd9f3"
          icon="bulb"
          data-testid="puff-notice-bulb-icon"
        />
      </div>
      <div className="puff-notice__notice-wrapper scope-cb8cd9f3">
        {" "}
        Elevate Your Designs with Puff: <br className="puff-notice__br scope-cb8cd9f3" />
        <a
          className="scope-cb8cd9f3"
          href="#image-design-tips"
          onClick={e => {
            e.stopPropagation();
          }}
          data-testid="puff-notice-a"
        >
          Tips to Get Started
        </a>
      </div>
    </div>
  );
}

export default PuffNotice;
